import { Injectable } from '@angular/core';
import { ApiService } from '../api/api.service';
import { DamageClaim } from 'src/app/models/damage-claim.model';
import { environment } from 'src/environments/environment';
import { Browser } from '@capacitor/browser';

@Injectable({
  providedIn: 'root',
})
export class AccidentDamageService {
  constructor(private readonly apiService: ApiService) { }

  getAccidentDamageClaims(icnNo: number) {
    let icnNo_ = `?icnNo=${icnNo}`;
    return this.apiService.get<DamageClaim[]>(`accident-damage/claims${icnNo_}`);
  }

  getUuidOfReportDamage(icnNo: number) {
    let icnNo_ = `?icnNo=${icnNo}`;
    return this.apiService.post<any, { returnResult: string }>(
      `accident-damage/reportaccidentdamage${icnNo_}`,
      { observe: 'response' },
    );
  }

  //Redirection logic based on damage report URL
  //Used in 'Emergency' and 'Accident Damage' screen
  onReportAccidentDamange(icnNo: number, isApp: boolean) {
    return this.getUuidOfReportDamage(icnNo).subscribe({
      next: async (response) => {
        if (!response.returnResult) return;

        const url = environment.reportAccidentDamageUrl
          .replace("${UUID}", response.returnResult);

        if (isApp) {
          await Browser.open({ url });
        } else {
          window.open(url, '_blank', 'noopener,noreferrer');
        }
      }
    });

  }
}
